export default __webpack_public_path__ + "static/media/light-blue-gradient.b58da2cd.svg";